import React from 'react';
import { Image, Text, View } from 'react-native';
import { getRegularFont } from '../../utils/Utils';
import { img_check, img_icon_search_x } from '../../utils/ImagesManagementUtils';

//= ========================================================================

const Avatar = ({
  globJSON,
  simPlatform,
  fullNameText,
  txtInitials,
  the_avatar_fn_color,
  the_avatar_bg_color,
  emptyBackground = false,
  style,
  withExitButton = false,
  emphasize = false,
  selectedContact = false,

}) => {
  const avatarSize = emphasize ? 28 : 23;
  const { colors } = globJSON.configurations.theme;

  const avatarStyles = {
    circle: {
      borderRadius: 17,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      width: avatarSize,
      height: avatarSize,
      backgroundColor: emptyBackground ? colors.app_background_color : the_avatar_bg_color,
    },
    fullNameText: {
      wordWrap: 'break-word',
      fontSize: 8,
      textAlign: 'center',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: avatarSize + 12,
      color: colors.primary_font_color,
    },
    exitButton: {
      width: 14,
      height: 14,
      position: 'absolute',
      left: '70%',
      top: '-15%',
      tintColor: colors.tertiary_icons_color,
    },
    check: {
      width: 20,
      height: 20,
      tintColor: colors.cta_font_color,
    },
    textInCircle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      color: emptyBackground ? the_avatar_fn_color : colors.cta_font_color,
      fontSize: emphasize ? 13 : 10.4,
    },
  };
  return (
    <View>
      {(!selectedContact
        ? (
          <View style={[avatarStyles.circle, style]}>
            {(withExitButton
              ? (
                <Image
                  fadeDuration={0}
                  style={avatarStyles.exitButton}
                  source={img_icon_search_x}
                />
              )
              : null)}
            <Text style={avatarStyles.textInCircle}>
              {txtInitials}
            </Text>
          </View>
        )
        : (
          <View
            style={[
              avatarStyles.circle, { backgroundColor: colors.positive_color },
              style]}
          >
            <Image
              fadeDuration={0}
              style={avatarStyles.check}
              source={img_check}
            />

          </View>
        )
            )}
      <Text
        style={avatarStyles.fullNameText}
      >
        {fullNameText}
      </Text>
    </View>

  );
};
export default Avatar;
